import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_service/auth.service';
import { SharedService } from '../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  forgetPasswordForm: FormGroup;submitted = false;loading=false;myrole='';userId='';
  constructor(private formBuilder: FormBuilder, private authapi:AuthService, private sharedapi:SharedService,private router:Router) {
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');
    if(this.myrole && this.userId)
    {
      this.router.navigate(['/dashboard']);
    }
    let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    this.forgetPasswordForm = this.formBuilder.group({
      'email' : [null, Validators.compose([Validators.required, Validators.pattern(vaildEmailAddress)])],
    });
  }
  get f() { return this.forgetPasswordForm.controls; }

  ngOnInit(): void {
  }

  async forgetPassword()
  {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.forgetPasswordForm.invalid) {
        this.loading = false;
        return;
    }

  await this.authapi.forgetUserPassword(this.forgetPasswordForm.value).subscribe((data:any) => {
      this.submitted = false;
      this.loading = false;
      if(data.status)
      {
        this.forgetPasswordForm.patchValue({
          'email': ''
        });
      }
      this.sharedapi.presentToast(data.msg);
    }, error =>
    {
      this.sharedapi.checkError(error);
    });
  }

}
